import { Link } from "react-router-dom";
import "./RecipeCard.css";

import placeholder from "../assets/placeholder.jpeg";


function RecipeCard({ recipe }) {
  const imageUrl = recipe.images?.[0]?.image_url || placeholder;

  return (
    <Link to={`/recipes/${recipe.id}`} className="recipe-card-link">
      <div className="recipe-card">
        <img src={imageUrl} alt={recipe.title} />
        <h3>{recipe.title}</h3>
      </div>
    </Link>
  );
}

export default RecipeCard;
